import { render, staticRenderFns } from "./centre_hopitalier_edit.vue?vue&type=template&id=a0a68be6&"
import script from "./centre_hopitalier_edit.vue?vue&type=script&lang=js&"
export * from "./centre_hopitalier_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports